export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/org/tree',
      method: 'GET'
    },
    {
      path: '/basis/org_type',
      method: 'GET'
    }]
  },
  tree: {
    funKey: 'tree',
    name: '树形展示',
    apis: [{
      path: '/basis/org/tree',
      method: 'GET'
    },
    {
      path: '/basis/position',
      method: 'GET'
    },
    {
      path: '/basis/org/all',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/basis/org',
      method: 'POST'
    },
    {
      path: '/basis/org_type',
      method: 'GET'
    },
    {
      path: '/basis/org/all',
      method: 'GET'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/basis/org/{id}',
      method: 'PUT'
    },
    {
      path: '/basis/org_type',
      method: 'GET'
    },
    {
      path: '/basis/org/all',
      method: 'GET'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/basis/org/{id}',
      method: 'DELETE'
    }]
  },
  goWorker: {
    funKey: 'goWorker',
    name: '跳转人员管理'
  },
  goCount: {
    funKey: 'goCount',
    name: '跳转统计页面'
  }
}